import React, { createContext, useContext, useMemo } from 'react'

type TourRequest = { requested: boolean; onHandled: () => void }

const TourRequestContext = createContext<TourRequest | null>(null)

type Props = TourRequest & { children: React.ReactNode }

// Only the standalone shell provides this, so the integrated surface never runs the tour.
export const TourRequestProvider = ({ requested, onHandled, children }: Props) => {
  const value = useMemo(() => ({ requested, onHandled }), [requested, onHandled])

  return <TourRequestContext.Provider value={value}>{children}</TourRequestContext.Provider>
}

export const useTourRequest = (): TourRequest | null => useContext(TourRequestContext)
